export const mapRadarData = (series, categories, colors, tooltip = {}, paneSize = '80%', showHamburger = true) => {

  const options = {
    chart: {
        polar: true,
        type: 'line',
    },
    title: {
        text: ''
    },
    pane: {
        size: paneSize
    },
    xAxis: {
        categories,
        tickmarkPlacement: 'on',
        lineWidth: 0
    },
    yAxis: {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0
    },
    legend: {
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical'
    },
    tooltip,
    colors,
    series,
    exporting: {
      enabled: showHamburger
    }
  };

  return options;
};